import * as React from "react";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { Distance } from "src/typings/microserviceModels/hotels-flex-module.d.ts";
import { LocalizedComponentProps } from "bernie-l10n";
import { Experiment, isVariantEnabled } from "src/components/utility/experiment";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { useLocalization } from "@shared-ui/localization-context";

interface NearestLocationProps extends LocalizedComponentProps {
  model?: Distance;
  shouldUseImperialDistanceUnits?: boolean;
  context?: ExtendedContextStore;
}

export const roundDistance = (distance: number) => Math.round(distance * 100) / 100;

export const NearestLocationContent = (props: NearestLocationProps) => {
  const { model, shouldUseImperialDistanceUnits, context } = props;
  const l10n = useLocalization();

  const isExperimentEnabled =
    context && isVariantEnabled(context, Experiment.Add_Distance_to_Nearest_Points_on_Hotel_cards);

  if (!isExperimentEnabled || !model) {
    return null;
  }

  const value = `${roundDistance(model.value)}`;
  /*Localization in progress*/
  const keyProperty = shouldUseImperialDistanceUnits
    ? "nearestLocationContent.cityCenterDistance.text.mi"
    : "nearestLocationContent.cityCenterDistance.text.km";

  const text = l10n.formatText(keyProperty, value) || `${value} ${model.unit} from city center`;

  return (
    <div className="uitk-cell all-t-padding-three uitk-flex uitk-flex-gap-two">
      <UitkIcon name="place" size={UitkIconSize.SMALL} />
      <span className="uitk-type-300">{text}</span>
    </div>
  );
};
